import FormGroupWrap from '@/library/components/form/helpers/FormGroupWrap';
import DisplayBoolean from '@/library/components/display/DisplayBoolean.tsx';
import _isBoolean from 'lodash/isBoolean';
import { FC, ReactNode } from 'react';
import { displayFormFieldValue } from '@/library/utils/form/display';
import { DisplayInputValueType } from '@/library/types/forms';

type FormFieldPreviewerProps = {
  label?: ReactNode | string;
  className?: string;
  value: number | string | null | boolean;
  type: DisplayInputValueType;
};

const FormFieldPreviewer: FC<FormFieldPreviewerProps> = ({
  label,
  className = '',
  value,
  type = 'string'
}) => {
  return (
    <FormGroupWrap className={className} label={label}>
      {type === 'boolean' || _isBoolean(value) ? (
        <DisplayBoolean isChecked={value as unknown as boolean} className="me-1" />
      ) : (
        <div className="fs-12 lh-base text-primary fw-medium form-field-preview">
          {displayFormFieldValue(value, type)}
        </div>
      )}
    </FormGroupWrap>
  );
};

export default FormFieldPreviewer;
